import { useState } from 'react';
import useContextMenu from '../../utils/customHooks/useContextMenu.js';
import Icon from '../../common/Icon';
import './styles.css';
import { TableUtil } from '../../utils/table.js';
import { Transforms } from 'slate';
import { ReactEditor } from 'slate-react';

const TableContextMenu = (props) => {
  const { editor } = props;
  const [selection, setSelection] = useState();
  const [showMenu, { top, left }] = useContextMenu(editor, 'table', setSelection);
  const table = new TableUtil(editor);

  const menu = [
    {
      icon: 'insertColumnLeft',
      text: 'ستون جدید سمت چپ',
      action: {
        type: 'insertColumn',
        position: 'after',
      },
    },
    {
      icon: 'insertColumnRight',
      text: 'ستون جدید سمت راست',
      action: {
        type: 'insertColumn',
        position: 'at',
      },
    },
    {
      icon: 'insertRowAbove',
      text: 'ردیف جدید بالا',
      action: {
        type: 'insertRow',
        positon: 'at',
      },
    },
    {
      icon: 'insertRowBelow',
      text: 'ردیف جدید پایین',
      action: {
        type: 'insertRow',
        position: 'after',
      },
    },
    {
      icon: 'trashCan',
      text: 'حذف ردیف',
      action: {
        type: 'removeRow',
        position: 'current',
      },
    },
    {
      icon: 'trashCan',
      text: 'حذف ستون',
      action: {
        type: 'removeColumn',
        position: 'current',
      },
    },
    {
      icon: 'trashCan',
      text: 'حذف جدول',
      action: {
        type: 'remove',
      },
    },
  ];

  const handleInsert = ({ type, position }) => {
    Transforms.select(editor, selection);
    switch (type) {
      case 'insertRow':
        table.insertRow(position);
        break;
      case 'removeRow':
        table.removeRow();
        break;
      case 'insertColumn':
        table.insertColumn(position);
        break;
      case 'removeColumn':
        table.removeColumn();
        break;
      case 'remove':
        table.removeTable();
        break;
      default:
        return;
    }
    ReactEditor.focus(editor);
  };

  return (
    showMenu && (
      <div className='contextMenu' style={{ top, left }}>
        {menu.map(({ icon, text, action }, index) => (
          <div className='menuOption' key={index} onClick={() => handleInsert(action)}>
            <Icon icon={icon} />
            <span>{text}</span>
          </div>
        ))}
      </div>
    )
  );
};

export default TableContextMenu;
